<template>
    <div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
		    <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
		    <el-breadcrumb-item :to="{ path: '/tenant/basic' }">场所信息</el-breadcrumb-item>
			<el-breadcrumb-item>场所程序模式码</el-breadcrumb-item>
		</el-breadcrumb>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入程序模式名进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search"
                              clearable
							  size="medium"
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                </div>
            </div>
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row style="margin-top: 10px">
                        <el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">场所联系人：</div>
								<div>
									<el-input placeholder="请输入场所联系人" size="medium" v-model="searchValue.ktiContacts"></el-input>
								</div>
							</div>
                        </el-col>
						<el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">联系方式：</div>
								<div>
									<el-input placeholder="请输入场所联系人方式" size="medium" v-model="searchValue.ktiContactWay"></el-input>
								</div>
							</div>
						</el-col>
                        <el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">场所状态：</div>
								<div>
									<el-radio-group v-model="searchValue.ktiIsEnable">
										<el-radio :label="0">启用</el-radio>
										<el-radio :label="1">停用</el-radio>
									</el-radio-group>
								</div>
							</div>
                        </el-col>
                        <el-col :span="6" >
							<div class="txt_align_right advance_btn_warp">
								<el-button size="mini" icon="el-icon-search" type="primary" @click="initEmps('advanced')">搜索</el-button>
							</div>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                <!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->
			<!-- 	<el-table-column
				        prop="kqmId"
				        label="程序模式ID"
				        align="center"
				        width="180">
				</el-table-column> -->
                <el-table-column
                        prop="kqmName"
                        align="center"
                        label="程序模式名称"
                        width="220">
						<template slot-scope="scope">
							<span>{{scope.row.kqmName}}（{{ktiName}}）</span>
						</template>
                </el-table-column>

                <el-table-column
                		align="center"
                        prop="kqmId"
                        min-width="40%"
                        label="H5链接地址">
                		<template slot-scope="scope">
                			<span>
                				<a target="_blank" :href="'https://bjzjsy.com/h5/#/index?modelId='+scope.row.kqmId+'&tenantId='+ktiId">
									https://bjzjsy.com/h5/#/index?modelId={{scope.row.kqmId}}&tenantId={{ktiId}}</a>
                			</span>
                		</template>
                </el-table-column>
                <el-table-column
                		align="center"
                        prop="kqmId"
                        min-width="10%"
                        label="H5二维码">
                		<template slot-scope="scope">
                			<span>
                				<a href="#" @click="getH5Qrcode(scope.row)">点击查看</a>
                				<!-- <a target="_blank" :href="'https://bjzjsy.com/h5/#/index?modelId='+scope.row.kqmId">https://bjzjsy.com/h5/#/index?modelId={{scope.row.kqmId}}</a> -->
                			</span>
                		</template>
                </el-table-column>
                <el-table-column
                		align="center"
                        prop="kqmId"
                        min-width="10%"
                        label="小程序二维码">
                		<template slot-scope="scope">
                			<span>
                				<a href="#" @click="getQrcode(scope.row)">点击查看</a>
                			</span>
                		</template>
                </el-table-column>

            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
		<el-dialog :visible.sync="qrcodeDialogVisible" width="50%" @open="showqrCode" ref="qrcodeDialog">
			<div style="display: flex;align-items: center;flex-direction: column;" id="mpQrCode">
				<div class="qrcode" ref="qrCodeUrl" style="width: 200px;"></div>
				<el-button size="medium" type="primary" plain style="width: 200px;margin-top: 20px;" @click="download()">下载二维码</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="h5QrcodeDialogVisible" width="50%" @open="showH5QrCode" ref="h5QrcodeDialog">
			<div style="display: flex;align-items: center;flex-direction: column;" id="h5QrCode">
				<div class="qrcode" ref="h5QrCodeUrl" style="width: 200px;"></div>
				<el-button size="medium" type="primary" plain style="width: 200px;margin-top: 20px;" @click="downloadH5()">下载二维码</el-button>
			</div>
		</el-dialog>
        
    </div>
</template>

<script>
	//所需页面导入
	import vue from 'vue'
	import QRCode from 'qrcodejs2'
    export default {
        name: "Tenants",
        data() {
            return {
                searchValue: {
					ktiContacts:'',
					ktiContactWay:'',
					ktiIsEnable:''
                },
                title: '',
				showAdvanceSearchView: false,
                allDeps: [],
                emps: [],
                loading: false,
                dialogVisible: false,
				qrcodeDialogVisible:false,
				h5QrcodeDialogVisible:false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
				tempTenantId:'',
                emp: {
					ktiName:'',
					ktiContacts:'',
					ktiContactWay:'',
					ktiIsEnable:'',
					ktiQrcode:''
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
				ktiId:'',
				ktiName:''
            }
        },
		created() {
			console.log(this.$route.query)
			this.ktiId = this.$route.query.ktiId
			this.ktiName = this.$route.query.ktiName
			this.initEmps();
			this.initData();
		},
        mounted() {

        },
        methods: {
            exportData() {
                window.open('/apis/tenant/basic/export', '_parent');
            },
            emptyEmp() {
                this.emp = {
                    name:'',
                    contacts:'',
                    contactWay:'',
                    isenable:'',
                    qrcodeUrl:''
                }
                this.inputDepName = '';
            },
            showEditEmpView(data) {
				console.log(data)
				data.ktiIsEnable = parseInt(data.ktiIsEnable)
                this.title = '编辑场所信息';
                this.emp = data;
                this.dialogVisible = true;
            },
			getQrcode(data){
				console.log(data.kqmId)
				this.tempKqmId = data.kqmId
				this.tempKqmName = data.kqmName
				this.qrcodeDialogVisible = true
			},
			getH5Qrcode(data){
				console.log(data.kqmId)
				this.tempKqmId = data.kqmId
				this.tempKqmName = data.kqmName
				this.h5QrcodeDialogVisible = true
			},
			showqrCode(){
				vue.nextTick(_ => {
					this.$refs.qrCodeUrl.innerHTML = '';
					var qrcode = new QRCode(this.$refs.qrCodeUrl, {
						text: 'https://wxjkcn.com/weixin/miniprogram/?modelId=' 
							+ this.tempKqmId + '&tempKqmName=' 
							+ this.tempKqmName + '&tenantId='
							+ this.ktiId, // 需要转换为二维码的内容
						width: 200,
						height: 200,
						colorDark: '#000000',
						colorLight: '#ffffff',
						correctLevel: QRCode.CorrectLevel.H
					})
				})
			},
			showH5QrCode(){
				vue.nextTick(_ => {
					this.$refs.h5QrCodeUrl.innerHTML = '';
					var qrcode = new QRCode(this.$refs.h5QrCodeUrl, {
						text: 'https://bjzjsy.com/h5/#/index?modelId='
						+ this.tempKqmId + '&tenantId='
						+ this.ktiId, // 需要转换为二维码的内容
						width: 200,
						height: 200,
						colorDark: '#000000',
						colorLight: '#ffffff',
						correctLevel: QRCode.CorrectLevel.H
					})
				})
				
			},
			downloadH5(){
				//获取canvas标签
				let canvas = document.getElementById('h5QrCode').getElementsByTagName('canvas')
				//创建a标签
				let a = document.createElement('a')
				//获取二维码的url并赋值为a.href
				a.href = canvas[0].toDataURL('img/png')
				//设置下载文件的名字
				a.download = '二维码'
				//点击事件，相当于下载
				a.click()
			},
			download() {
				//获取canvas标签
				let canvas = document.getElementById('mpQrCode').getElementsByTagName('canvas')
				//创建a标签
				let a = document.createElement('a')
				//获取二维码的url并赋值为a.href
				a.href = canvas[0].toDataURL('img/png')
				//设置下载文件的名字
				a.download = '二维码'
				//点击事件，相当于下载
				a.click()
			},

            initData() {
				
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },

            initEmps(type) {
                this.loading = true;
                let url = '/questionModel/basic/getQuestionModels?page=' + this.page + '&size=' + this.size;
                url += "&keyword=" + this.keyword;
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
	.el-form-item {
		display: flex;
		.input_box {
			width: 14.5rem;
			.el-input {
				width: 100% !important;
			}
		}
	}
	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;
		.box_tit {
			font-size: 0.875rem;
		}
	}
	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}
</style>
